// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".4dd6b8a0b02afdf6d0fab78bafdccc29.js";
};